import styled from "styled-components";

export const ScannerWrapper = styled.div`
  position: relative;
  min-height: 80vh;
  width: 100%;
  background: #000;

  .addBoxText {
    padding-top: 5px;
    font-weight: 600;
    font-size: 15px;
    color: #fff;
    margin-left: 10px;
  }
`;
